export default {"src":"/_next/static/media/introBanner.ec936859.svg","height":384,"width":434,"blurWidth":0,"blurHeight":0};